import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axiosRequest from './request/request'
import rem from '@/utils/rem'
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'

Vue.use(element)
// mock模拟数据
import "./mock"

// import style (>= Swiper 6.x)

rem()
Vue.use(axiosRequest)
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


